<template>
    <div class="mod mod-half mod-fbl">
        <h2><i>8</i>涨跌停走势</h2>
        <div class="chart-tab">
            <span v-for="(item,index) in tabs" :class="{'cur':curTab==index}" @click="curTab=index,tabChange(index)">{{item}}</span>
        </div>
        <keep-alive>
            <component v-bind:is="curTabComponent"></component>
        </keep-alive>
    </div>
</template>

<script>
    import zdtzsToday from './zdtzsToday.vue';      // 日
    import zdtzsMonth from './zdtzsMonth.vue';      // 月
    export default {
        data () {
            return {
                isHelp:false,
                tabs:['日','月'],
                curTab:0,
                curTabComponent: 'zdtzsToday'
            }
        },
        components: {
            zdtzsToday,
            zdtzsMonth
        },
        methods: {
            tabChange:function(index){
                switch(index)
                {
                    case 1:
                        this.curTabComponent = 'zdtzsMonth';
                        break;
                    default:
                        this.curTabComponent = 'zdtzsToday';
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/home/components/zdtzs.vue